const de_DE = {}

de_DE.strings = {
  addBulkFilesFailed: {
    '0': 'Das HinzufÃÂ¼gen einer Datei ist aufgrund eines internen Fehlers fehlgeschlagen',
    '1': 'Das HinzufÃÂ¼gen von %{smart_count} Dateien ist aufgrund eines internen Fehlers fehlgeschlagen',
  },
  addingMoreFiles: 'Dateien hinzufÃÂ¼gen',
  addMore: 'Mehr hinzufÃÂ¼gen',
  addMoreFiles: 'Dateien hinzufÃÂ¼gen',
  allFilesFromFolderNamed: 'Alle Dateien vom Ordner %{name}',
  allowAccessDescription: 'Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte den Zugriff auf Ihre Kamera.',
  allowAccessTitle: 'Bitte erlauben Sie Zugriff auf Ihre Kamera',
  aspectRatioLandscape: 'Zuschneiden auf Querformat (16:9)',
  aspectRatioPortrait: 'Zuschneiden auf Hochformat (9:16)',
  aspectRatioSquare: 'Zuschneiden auf Quadrat',
  authenticateWith: 'Mit %{pluginName} verbinden',
  authenticateWithTitle: 'Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuwÃÂ¤hlen',
  back: 'ZurÃÂ¼ck',
  backToSearch: 'ZurÃÂ¼ck zur Suche',
  browse: 'durchsuchen',
  browseFiles: 'Dateien durchsuchen',
  browseFolders: 'Ordner durchsuchen',
  cancel: 'Abbrechen',
  cancelUpload: 'Hochladen abbrechen',
  chooseFiles: 'Dateien auswÃÂ¤hlen',
  closeModal: 'Fenster schlieÃÂen',
  companionError: 'Verbindung zu Companion fehlgeschlagen',
  companionUnauthorizeHint: 'Um die Autorisierung fÃÂ¼r Ihr %{provider} Konto aufzuheben, gehen Sie bitte zu %{url}',
  complete: 'Fertig',
  connectedToInternet: 'Mit dem Internet verbunden',
  copyLink: 'Link kopieren',
  copyLinkToClipboardFallback: 'Untenstehende URL kopieren',
  copyLinkToClipboardSuccess: 'Link in die Zwischenablage kopiert',
  creatingAssembly: 'Das Hochladen wird vorbereiten...',
  creatingAssemblyFailed: 'Transloadit: Assembly konnte nicht erstellt werden',
  dashboardTitle: 'Hochladen von Dateien',
  dashboardWindowTitle: 'Hochladen von Dateien (ESC drÃÂ¼cken zum SchlieÃÂen)',
  dataUploadedOfTotal: '%{complete} von %{total}',
  discardRecordedFile: 'Aufgenommene Datei verwerfen',
  done: 'Abgeschlossen',
  dropHereOr: 'Dateien hier ablegen oder %{browse}',
  dropHint: 'Dateien hier ablegen',
  dropPasteBoth: 'Dateien hier ablegen/einfÃÂ¼gen, %{browseFiles} oder %{browseFolders}',
  dropPasteFiles: 'Dateien hier ablegen/einfÃÂ¼gen oder %{browseFiles}',
  dropPasteFolders: 'Dateien hier ablegen/einfÃÂ¼gen oder %{browseFolders}',
  dropPasteImportBoth: 'Dateien hier ablegen/einfÃÂ¼gen, %{browse} oder von folgenden Quellen importieren:',
  dropPasteImportFiles: 'Dateien hier ablegen/einfÃÂ¼gen, %{browseFiles} oder von folgenden Quellen importieren:',
  dropPasteImportFolders: 'Dateien hier ablegen/einfÃÂ¼gen, %{browseFolders} oder von folgenden Quellen importieren:',
  editFile: 'Datei bearbeiten',
  editing: '%{file} bearbeiten',
  emptyFolderAdded: 'Keine Dateien hinzugefÃÂ¼gt, da der Ordner leer war',
  encoding: 'Kodieren...',
  enterCorrectUrl: 'Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben',
  enterTextToSearch: 'Text zum Suchen von Bildern eingeben',
  enterUrlToImport: 'URL zum Importieren einer Datei eingeben',
  exceedsSize: 'Datei %{file} ist grÃÂ¶ÃÂer als die maximal erlaubte DateigrÃÂ¶ÃÂe von %{size}',
  failedToFetch: 'Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist',
  failedToUpload: 'Fehler beim Hochladen der Datei %{file}',
  filesUploadedOfTotal: {
    '0': '%{complete} von %{smart_count} Datei hochgeladen',
    '1': '%{complete} von %{smart_count} Dateien hochgeladen',
  },
  filter: 'Filter',
  finishEditingFile: 'Bearbeitung beenden',
  flipHorizontal: 'Horizontal spiegeln',
  folderAdded: {
    '0': 'Eine Datei von %{folder} hinzugefÃÂ¼gt',
    '1': '%{smart_count} Dateien von %{folder} hinzugefÃÂ¼gt',
  },
  folderAlreadyAdded: 'Der Ordner "%{folder}" wurde bereits hinzugefÃÂ¼gt',
  generatingThumbnails: 'Erstellen von Miniaturansichten...',
  import: 'Importieren',
  importFiles: 'Importiere Dateien von:',
  importFrom: 'Importieren von %{name}',
  inferiorSize: 'Diese Datei ist kleiner als die minimal erlaubte DateigrÃÂ¶ÃÂe von %{size}',
  loading: 'Laden...',
  logOut: 'Abmelden',
  micDisabled: 'Zugriff auf Mikrofon von Benutzer abgelehnt',
  missingRequiredMetaField: 'Fehlende erforderliche Meta-Felder',
  missingRequiredMetaFieldOnFile: 'Fehlende erforderliche Meta-Felder in %{fileName}',
  myDevice: 'Mein GerÃÂ¤t',
  noCameraDescription: 'Bitte Kamera anschlieÃÂen, um Bilder oder Videos aufzunehmen',
  noCameraTitle: 'Kamera nicht verfÃÂ¼gbar',
  noDuplicates: 'Datei \'%{fileName}\' existiert bereits und kann nicht erneut hinzugefÃÂ¼gt werden',
  noFilesFound: 'Sie haben hier keine Dateien oder Ordner',
  noInternetConnection: 'Keine Internetverbindung',
  noMoreFilesAllowed: 'WÃÂ¤hrend der Upload lÃÂ¤uft, kÃÂ¶nnen keine weiteren Dateien hinzugefÃÂ¼gt werden',
  openFolderNamed: 'Ordner %{name} ÃÂ¶ffnen',
  pause: 'Pausieren',
  paused: 'Pausiert',
  pauseUpload: 'Hochladen pausieren',
  pluginNameBox: 'Box',
  pluginNameCamera: 'Kamera',
  pluginNameDropbox: 'Dropbox',
  pluginNameFacebook: 'Facebook',
  pluginNameGoogleDrive: 'Google Drive',
  pluginNameInstagram: 'Instagram',
  pluginNameOneDrive: 'OneDrive',
  pluginNameZoom: 'Zoom',
  poweredBy: 'Powered by %{uppy}',
  processingXFiles: {
    '0': 'Eine Datei verarbeiten',
    '1': '%{smart_count} Dateien verarbeiten',
  },
  recording: 'Aufnahme',
  recordingLength: 'Aufnahmedauer %{recording_length}',
  recordingStoppedMaxSize: 'Die Aufnahme wurde gestoppt, weil die DateigrÃÂ¶ÃÂe das Limit ÃÂ¼berschritten hat',
  recoveredAllFiles: 'Wir haben alle Dateien wiederhergestellt. Sie kÃÂ¶nnen mit dem Hochladen fortfahren.',
  recoveredXFiles: {
    '0': 'Wir konnten eine Datei nicht vollstÃÂ¤ndig wiederherstellen. Bitte wÃÂ¤hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort.',
    '1': 'Wir konnten %{smart_count} Dateien nicht vollstÃÂ¤ndig wiederherstellen. Bitte wÃÂ¤hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort.',
  },
  removeFile: 'Datei entfernen',
  reSelect: 'Erneut auswÃÂ¤hlen',
  resetFilter: 'Filter zurÃÂ¼cksetzen',
  resume: 'Fortsetzen',
  resumeUpload: 'Hochladen fortsetzen',
  retry: 'Erneut versuchen',
  retryUpload: 'Hochladen erneut versuchen',
  revert: 'RÃÂ¼ckgÃÂ¤ngig machen',
  rotate: 'Drehen',
  save: 'Speichern',
  saveChanges: 'ÃÂnderungen speichern',
  searchImages: 'Suche nach Bildern',
  selectX: {
    '0': 'WÃÂ¤hlen Sie %{smart_count}',
    '1': 'WÃÂ¤hlen Sie %{smart_count}',
  },
  sessionRestored: '',
  smile: 'Bitte lÃÂ¤cheln!',
  startCapturing: 'Bildschirmaufnahme starten',
  startRecording: 'Videoaufnahme starten',
  stopCapturing: 'Bildschirmaufnahme stoppen',
  stopRecording: 'Videoaufnahme stoppen',
  streamActive: 'Stream aktiv',
  streamPassive: 'Stream passiv',
  submitRecordedFile: 'Aufgezeichnete Datei verwenden',
  takePicture: 'Ein Foto machen',
  timedOut: 'Upload fÃÂ¼r %{seconds} Sekunden stehen geblieben, breche ab.',
  upload: 'Hochladen',
  uploadComplete: 'Hochladen abgeschlossen',
  uploadFailed: 'Hochladen fehlgeschlagen',
  uploading: 'Wird hochgeladen',
  uploadingXFiles: {
    '0': 'Eine Datei wird hochgeladen',
    '1': '%{smart_count} Dateien werden hochgeladen',
  },
  uploadPaused: 'Hochladen pausiert',
  uploadXFiles: {
    '0': 'Eine Datei hochladen',
    '1': '%{smart_count} Dateien hochladen',
  },
  uploadXNewFiles: {
    '0': '+%{smart_count} Datei hochladen',
    '1': '+%{smart_count} Dateien hochladen',
  },
  xFilesSelected: {
    '0': 'Eine Datei ausgewÃÂ¤hlt',
    '1': '%{smart_count} Dateien ausgewÃÂ¤hlt',
  },
  xMoreFilesAdded: {
    '0': 'Eine weitere Datei hinzugefÃÂ¼gt',
    '1': '%{smart_count} weitere Dateien hinzugefÃÂ¼gt',
  },
  xTimeLeft: '%{time} verbleibend',
  youCanOnlyUploadFileTypes: 'Sie kÃÂ¶nnen nur folgende Dateitypen hochladen: %{types}',
  youCanOnlyUploadX: {
    '0': 'Sie kÃÂ¶nnen nur eine Datei hochladen',
    '1': 'Sie kÃÂ¶nnen nur %{smart_count} Dateien hochladen',
  },
  youHaveToAtLeastSelectX: {
    '0': 'Sie mÃÂ¼ssen mindestens eine Datei auswÃÂ¤hlen',
    '1': 'Sie mÃÂ¼ssen mindestens %{smart_count} Dateien auswÃÂ¤hlen',
  },
  zoomIn: 'VergrÃÂ¶ÃÂern',
  zoomOut: 'Verkleinern',
}

de_DE.pluralize = function pluralize (count) {
  if (count === 1) {
    return 0
  }
  return 1
}

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.de_DE = de_DE
}

module.exports = de_DE
